module.exports = {"content":{},"productInfo":{"code":"{FFA5DA4D-A729-4DD7-BA87-59ED6DF29969}","name":"アイルランド語　初中級","serialHead":"BYWRA","courseResourceIDs":[{"levelNo":1,"resourceID":"505b20caf525126504faeca8933e9c4a824008cc"},{"levelNo":2,"resourceID":"c7160ea895fb36506ca21aee87c63846c57f839e"},{"levelNo":3,"resourceID":"de034083c5fe3d27b8c7b1a3680c3b58d3810735"}],"language":"ga-IE","challengeCount":21880},"version":"1.1.1"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1